export const APP_INFORMATION_PAGE_LABELS = {
	landing: 'Landing',
	login: 'Login',
	register: 'Register',
	forgotPassword: 'Forgot Password',
	beranda: 'Beranda',
	detailAkun: 'Detail Akun',
	phoneVerification: 'Verifikasi Nomor HP',
	notifikasi: 'Notifikasi',
	liveClass: 'Live Class',
	supportTickets: 'Tiket Bantuan',
	leaderboard: 'Leaderboard',
	paket: 'Paket & Harga',
	kalkulator: 'Kalkulator',
	about: 'Tentang Cadira',
	psikologi: 'Menu Psikologi',
	kecermatan: 'Kecermatan',
	akademik: 'Menu Akademik',
	jasmani: 'Menu Jasmani',
	informasiTest: 'Informasi Test',
	pgTestRunner: 'Runner Test PG',
	kecermatanRunner: 'Runner Test Kecermatan',
	jasmaniRunner: 'Runner Test Jasmani',
	testResult: 'Hasil Test',
	testReview: 'Pembahasan Test',
};

const trimSlashes = (value = '') => value.replace(/^\/+|\/+$/g, '');

export const getPlacementFromPathname = (pathname = '/') => {
	const normalizedPath = `/${trimSlashes(pathname)}`;
	const segments = trimSlashes(pathname).split('/').filter(Boolean);

	if (normalizedPath === '/') return 'landing';
	if (segments[0] === 'login') return 'login';
	if (segments[0] === 'register') return 'register';
	if (segments[0] === 'forgot-password') return 'forgotPassword';
	if (segments[0] === 'leaderboard') return 'leaderboard';
	if (segments[0] === 'paket') return 'paket';
	if (segments[0] === 'kalkulator') return 'kalkulator';
	if (segments[0] === 'about') return 'about';

	if (segments[0] === 'beranda') {
		if (segments[1] === 'detail-akun') return 'detailAkun';
		if (segments[1] === 'verifikasi-nomor-hp') return 'phoneVerification';
		if (segments[1] === 'notifikasi') return 'notifikasi';
		if (segments[1] === 'live-class') return 'liveClass';
		if (segments[1] === 'tiket-bantuan') return 'supportTickets';
		return 'beranda';
	}

	if (segments[0] === 'psikologi') {
		if (segments.includes('informasi')) return 'informasiTest';
		if (segments.includes('result')) return 'testResult';
		if (segments.includes('pembahasan')) return 'testReview';
		if (segments.includes('kerjakan-test')) {
			return segments[1] === 'kecermatan' ? 'kecermatanRunner' : 'pgTestRunner';
		}
		if (segments[1] === 'kecermatan') return 'kecermatan';
		return 'psikologi';
	}

	if (segments[0] === 'akademik') {
		if (segments.includes('informasi')) return 'informasiTest';
		if (segments.includes('kerjakan-test')) return 'pgTestRunner';
		if (segments.includes('result')) return 'testResult';
		if (segments.includes('pembahasan')) return 'testReview';
		return 'akademik';
	}

	if (segments[0] === 'jasmani') {
		if (segments.includes('informasi')) return 'informasiTest';
		if (segments.includes('mulai-test')) return 'jasmaniRunner';
		return 'jasmani';
	}

	return '';
};
